/**
 * Created by razial on 27.04.2024.
 */

const WarehouseWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        this.bundle = bundles[this.getBundleName()];
        this._super({
            name: "WarehouseWindow",
            content: this.createContent(),
            title: false,
            noBackground: true,
            notCloseByTouchInShadow: true,
            openSound: this.bundle.urls.open_effect
        });

        this.createScroll();
        this.createBackground();
        this.createCapacity();
        this.onWarehouseChanged();

        cleverapps.focusManager.showControlsWhileFocused(["MenuBarAvatarItem", "MenuBarGoldItem"]);
        cleverapps.tutorial.trigger("warehouse_window_opened");

        Map2dLocation.currentLocation.harvested.on("onChangeItems", this.onWarehouseChanged.bind(this), this);
    },

    createDialogue: function (options) {
        options = options || {};
        const rects = [this.capacity.getSceneBoundingBox(), this.window.getSceneBoundingBox(), this.closeButton.getSceneBoundingBox()];
        if (options.items) {
            rects.push(this.scroll.getSceneBoundingBox());
        }
        const dialogue = new MinimalDialogue({
            text: Messages.get(options.text || "WarehouseWindow.notEnoughSpace"),
            rects,
            person: options.person,
            position: options.position
        });
        this.addChild(dialogue);
        dialogue.display();
        if (options.closeHint) {
            this.finger = FingerView.hintTap(this.closeButton, {
                delay: options.closeHint.delay || 0.1,
                repeatDelay: 0.1
            });
        }
        return dialogue;
    },

    onShow: function () {
        if (Map2dLocation.currentLocation.harvested.wantsToShowTip) {
            const dialogue = this.createDialogue();

            this.runAction(new cc.Sequence(
                new cc.DelayTime(6),
                new cc.CallFunc(() => {
                    dialogue.remove();
                })
            ));
        }
    },

    createContent: function () {
        return new cc.Node();
    },

    createScroll: function () {
        const styles = cleverapps.styles.WarehouseWindow;

        this.window.removeFromParent();
        this.window = new cc.Node();
        this.window.setAnchorPoint(0.5, 0);
        this.addChild(this.window);

        const tiles = Map2dLocation.currentLocation.harvested.listResources().map((ingredient, index, tiles) => {
            const tile = new WarehouseTile(ingredient.ingredient, this.selectTile.bind(this), this.bundle);
            tile.setLocalZOrder(tiles.length - index);
            return tile;
        });

        if (!tiles.length) {
            tiles.push(this.createEmptyTile());
        }

        const layout = new cleverapps.Layout(tiles, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.scroll.margin,
            padding: styles.scroll.padding
        });

        this.scroll = new cleverapps.UI.ScrollView(layout, {
            direction: cleverapps.UI.ScrollView.DIR_HORIZONTAL,
            clipping: false,
            scrollBarEnabled: false
        });
        this.scroll.setContentSize(this.width, layout.height);
        this.scroll.setAnchorPoint(0.5, 0);
        this.scroll.scrollTo(cleverapps.UI.ScrollView.SCROLLS.UPPER_LEFT);
        this.window.addChild(this.scroll, 1);
    },

    createBackground: function () {
        this.background = cleverapps.UI.createScale9Sprite(this.bundle.frames.background, cleverapps.UI.Scale9Rect.TwoPixelXY);
        this.background.setAnchorPoint(0.5, 0);
        this.background.setLocalZOrder(-1);
        this.window.addChild(this.background);
    },

    createCapacity: function () {
        const styles = cleverapps.styles.WarehouseWindow.capacity;

        const title = cleverapps.UI.generateOnlyText(Messages.get("WarehouseWindow.capacity"), cleverapps.styles.FONTS.WAREHOUSE_CAPACITY_TEXT);

        const current = Map2dLocation.currentLocation.harvested.getItemsAmount();
        const total = Map2dLocation.currentLocation.harvested.getCapacity();

        const value = cleverapps.UI.generateOnlyText(`${current}/${total}`, cleverapps.styles.FONTS.WAREHOUSE_CAPACITY_TEXT);

        const capacityBlock = new cleverapps.Layout([title, value], {
            direction: cleverapps.UI.VERTICAL
        });

        const price = Map2dLocation.currentLocation.harvested.getUpgradePrice();

        const content = new cleverapps.Layout([
            cleverapps.UI.generateOnlyText(Messages.get("WarehouseWindow.upgrade"), cleverapps.styles.FONTS.BUTTON_TEXT),
            new TextWithIcon(`$$${price}`, { font: cleverapps.styles.FONTS.BUTTON_TEXT })
        ], {
            direction: cleverapps.UI.VERTICAL,
            padding: styles.button.padding
        });

        const upgradeButton = new cleverapps.UI.Button({
            content,
            width: styles.button.width,
            height: styles.button.height,
            onClicked: function () {
                if (cleverapps.user.spendHard(cleverapps.EVENTS.SPENT.WAREHOUSE, price)) {
                    Map2dLocation.currentLocation.harvested.upgradeCapacity();
                }
            }
        });

        this.capacity = new cleverapps.Layout([upgradeButton, capacityBlock], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin,
            padding: styles.padding
        });
        this.capacity.setAnchorPoint(1, 0);
        this.window.addChild(this.capacity);
        if (Map2dLocation.currentLocation.harvested.hideCapacity()) {
            this.capacity.setVisible(false);
        }
        this.capacity.value = value;
    },

    createEmptyTile: function () {
        const styles = cleverapps.styles.WarehouseWindow.emptyTile;

        const container = new cc.Node();
        container.setAnchorPoint(0.5, 0.5);
        container.setContentSize(styles);

        const background = cleverapps.UI.createScale9Sprite(this.bundle.frames.tile_background);
        background.setContentSize(styles.background);
        background.setAlignment(styles.background);
        container.addChild(background);

        const text = cleverapps.UI.generateOnlyText(Messages.get("WarehouseWindow.empty"), cleverapps.styles.FONTS.WAREHOUSE_TILE_TITLE_TEXT);
        text.fitTo(styles.text.width);
        text.setAlignment(styles.text);
        background.addChild(text);

        return container;
    },

    onAfterResize: function () {
        this._super();

        const bgSize = cleverapps.resolution.getBgSize();

        const safePadding = cleverapps.resolution.getSafePadding();
        this.window.setContentSize(bgSize.width, this.scroll.height);
        this.window.setPosition(bgSize.width / 2 - safePadding.left, 0);

        this.scroll.setContentSize2(bgSize.width, this.scroll.height);
        this.scroll.setPosition(this.window.width / 2, 0);

        this.updateBackground();
        this.updateCapacity();
    },

    updateBackground: function () {
        const styles = cleverapps.styles.WarehouseWindow;

        const width = this.scroll.width;
        const height = this.scroll.height;
        const safePadding = cleverapps.resolution.getSafePadding();

        this.background.setContentSize2(
            width + 2 * styles.background.padding,
            height + styles.background.padding + safePadding.bottom
        );
        this.background.setPosition(width / 2, -styles.background.padding - safePadding.bottom);

        this.background.removeAllChildren();

        const lines = Math.floor(this.background.width / styles.background.linesMargin);

        for (let i = 0; i < lines - 1; i++) {
            const line = cleverapps.UI.createScale9Sprite(this.bundle.frames.background_line, cleverapps.UI.Scale9Rect.TwoPixelXY);
            line.setContentSize(this.background.width, line.height);
            line.setAnchorPoint(0.5, 0.5);
            line.setPosition(this.background.width / 2, this.background.height - styles.background.linesPadding - (i + 1) * styles.background.linesMargin);
            this.background.addChild(line);
        }
    },

    updateCapacity: function () {
        this.capacity.setPosition(this.scroll.width, this.scroll.height);
    },

    onWarehouseChanged: function () {
        const current = Map2dLocation.currentLocation.harvested.getItemsAmount();
        const total = Map2dLocation.currentLocation.harvested.getCapacity();

        if (Map2dLocation.currentLocation.harvested.isFull()) {
            this.capacity.value.setColor(cleverapps.styles.COLORS.COLOR_RED);
        } else {
            this.capacity.value.setColor(cleverapps.styles.COLORS.WHITE);
        }

        this.capacity.value.setString(`${current}/${total}`);
        this.capacity.reshape();
    },

    selectTile: function (tile) {
        if (this.selectedTile) {
            this.selectedTile.unselectTile();
        }

        this.selectedTile = tile;

        if (this.selectedTile) {
            this.selectedTile.selectTile();
        }
    },

    chooseAnimation: function () {
        return WINDOW_ANIMATIONS.fromBelow;
    },

    getBundleName: function () {
        return [`warehousewindow_${cleverapps.meta.selectedLocationId()}`, "warehousewindow"].find((bundleName) => bundles[bundleName]);
    },

    listBundles: function () {
        return [this.getBundleName()];
    },

    onClose: function () {
        cleverapps.tutorial.trigger("warehouse_window_closed");
        if (this.finger) {
            FingerView.remove(this.finger);
            this.finger = undefined;
        }
        this._super();
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    WAREHOUSE_TILE_TITLE_TEXT: {
        name: "nostroke",
        size: 42,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    WAREHOUSE_TILE_AMOUNT_TEXT: {
        name: "nostroke",
        size: 74,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    WAREHOUSE_CAPACITY_TEXT: {
        size: 64,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    }
});

cleverapps.styles.WarehouseWindow = {
    background: {
        linesPadding: 30,
        linesMargin: 70,
        padding: 150
    },

    scroll: {
        margin: 30,
        padding: {
            x: 60,
            top: 70,
            bottom: 20
        }
    },

    capacity: {
        margin: 20,
        padding: {
            x: 20,
            y: 20
        },

        button: {
            width: 300,
            height: 140,

            padding: {
                top: 10
            }
        }
    },

    emptyTile: {
        width: 650,
        height: 540,

        background: {
            x: { align: "center" },
            y: { align: "center" },
            width: 650,
            height: 180
        },

        text: {
            x: { align: "center" },
            y: { align: "center" },
            width: 500
        }
    }
};